import ElementUI from '@/plugins/element-ui-bridge'

import util from '@/tools/util.js'

import store from '@/store/index.js'

const Message =
  (ElementUI && ElementUI.Message) ||
  (typeof window !== 'undefined' && window.myapp && window.myapp.$message) ||
  function () {}

import imgURL from '../assets/lock.png'

const transferArrayBufferToJSON = (arrayBufferData) => {
  var uint8_msg = new Uint8Array(arrayBufferData)
	// 解码成字符串
  var decodedString = String.fromCharCode.apply(null, uint8_msg)
  console.log(decodedString)
  var data = null
	// parse,转成json数据
  try {
    data = JSON.parse(decodedString)
  } catch (error) {
    data = decodedString
  }
  return data
}

export default function showErr (err) {
  // 请求取消
  // alert(JSON.stringify(err));
  // console.log(err);
  // console.log(!!(err.status.match(/canceled/i)), err);
  if (typeof err.status === 'number' && (err.status === 0 || err.status === 401 || err.status === 404 || err.status === 418)) {
    return false
  }
  if (err.status === 403) {
    if (store.getters.lock_errors.includes('req_access_fail')) {
      // return false;
    } else {
      store.dispatch('other/addLockErrorMsg', 'req_access_fail')
    }
  }

  if (err.body.constructor === ArrayBuffer) {
    err.body = transferArrayBufferToJSON(err.body)
  }

  // console.log(err, 'err.status')
  if (err.status === 403 && err.body.reason === 'NO_OPERATION_PERMISSION') {
    // 对403进行特殊处理
    Message({
      iconClass: 'manban-toast__none',
      dangerouslyUseHTMLString: true,
      message: `<img style="width: 30px; height: 40px; display: block; margin: 0 auto 12px;" src="${imgURL}" />
                <p>${err.body.error ? err.body.error : '你没有权限操作此数据'}</p>`,
      customClass: 'manban-toast__error403',
      duration: 1000,
      onClose: () => {
        if (err.status === 403) {
          store.dispatch('other/delLockErrorMsg', 'req_access_fail')
        }
      }
    })
  } else if (err.status === 403 && err.body.reason === 'NO_VIEW_PERMISSION') {
    store.dispatch('other/delLockErrorMsg', 'req_access_fail')
  } else {
    // 判断不报错的信息
    if (err.body.error === '您今日的下载次数以达到上限，请明日再来') {
      if (err.status === 403) {
        store.dispatch('other/delLockErrorMsg', 'req_access_fail')
      }
      return
    }

    Message({
      type: 'error',
      message: err.body.error ? err.body.error : util.setDefaultErr(),
      customClass: 'manban-toast__error',
      onClose: () => {
        if (err.status === 403) {
          store.dispatch('other/delLockErrorMsg', 'req_access_fail')
        }
      }
    })
  }
}
